export const privacyPolicy = [
  {
    id: 1,
    title: "1. Introduction",
    content: `
Welcome to Magyne.

Your privacy is important to us. This Privacy Policy explains how
Magyne Technologies collects, uses, stores and protects your
personal information whenever you use our websites, cloud services
and software applications.

By using any Magyne service, you agree to the practices described
in this Privacy Policy.
`
  },

  {
    id: 2,
    title: "2. Information We Collect",
    content: `
We may collect information including:

• Personal details such as your name, email address and phone number.

• Business information including your company name, registration details and business address.

• Account credentials used to access Magyne services.

• Device information such as browser type, operating system and IP address.

• Usage information describing how you interact with our platform.
`
  },

  {
    id: 3,
    title: "3. How We Use Your Information",
    content: `
We use your information to:

• Create and manage your account.

• Deliver cloud software services.

• Process subscriptions and payments.

• Improve system performance.

• Provide customer support.

• Detect fraud and unauthorized access.

• Comply with legal obligations.
`
  },

  {
    id: 4,
    title: "4. Data Security",
    content: `
Magyne implements industry-standard technical and organizational
security controls including encryption, secure authentication,
role-based access control, tenant isolation and regular security
monitoring to safeguard customer information.
`
  },

  {
    id: 5,
    title: "5. Data Sharing",
    content: `
We do not sell customer information.

Information may only be shared with trusted service providers,
payment processors or government authorities where legally required.
`
  },

  {
    id: 6,
    title: "6. Cookies",
    content: `
Cookies help us remember your preferences, improve performance,
maintain secure sessions and analyze website traffic.

You can disable cookies through your browser settings, although
certain features may no longer function correctly.
`
  },

  {
    id: 7,
    title: "7. Your Rights",
    content: `
Depending on applicable law, you may request to:

• Access your information.

• Correct inaccurate information.

• Delete your information.

• Export your information.

• Restrict certain processing activities.

• Withdraw consent where applicable.
`
  },

  {
    id: 8,
    title: "8. Contact Us",
    content: `
If you have any questions regarding this Privacy Policy,
please contact Magyne Technologies through our official
support channels.
`
  }
];